// Used for caching the list of manufacturers

import $api from '@/services/api';

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
  },
  getters: {
    getLoading: (state) => {
      return state.loading;
    },
    getManufacturers: (state) => {
      return state.list;
    },
    getManufacturer: (state) => (id) => {
      return state.list.find((m) => m.id === id) || null;
    },
  },
  mutations: {
    setManufacturers(state, val) {
      state.list = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    ensure({ state, dispatch }) {
      if (!state.list.length) {
        dispatch('fetch');
      }
    },
    // Load the device details and templates for the device
    async fetch({ state, commit }) {
      if (state.loading) return;
      commit('setLoading', true);

      try {
        const manufacturers = await $api.get('/v1/internal/manufacturers');
        manufacturers.sort((a, b) => a.name.localeCompare(b.name));
        commit('setManufacturers', manufacturers);
      } catch (err) {
        commit('setManufacturers', []);
      }
      commit('setLoading', false);
    },
  },
};
